// Venue-exposure strip: every event sponsor with logo/initial, name and type; marquee when there are many
export default function SponsorSlide({ sponsors, testid = "tv-sponsors" }) {
  if (!sponsors?.length) return null;
  const marquee = sponsors.length > 4;
  const items = marquee ? [...sponsors, ...sponsors] : sponsors;
  return (
    <div className="border-t border-amber-400/30 bg-gradient-to-r from-black via-amber-400/[0.06] to-black px-8 py-3 overflow-hidden" data-testid={testid}>
      <div className="flex items-center gap-8">
        <span className="shrink-0 text-[10px] uppercase tracking-[0.4em] text-amber-300 font-black">Thank you to our sponsors</span>
        <div className="flex-1 overflow-hidden">
          <div className={`flex items-center gap-10 ${marquee ? "tv-marquee" : "justify-around"}`} style={marquee ? { width: "max-content" } : undefined}>
            {items.map((sp, i) => (
              <div key={i} className="flex items-center gap-3 shrink-0" data-testid={i < sponsors.length ? `${testid}-${i}` : undefined}>
                {sp.logo ? <img src={sp.logo} alt={sp.name} className="h-12 max-w-[160px] object-contain" />
                  : <span className="h-12 w-12 grid place-items-center bg-pb-elevated text-xl font-black text-zinc-300">{sp.name[0]}</span>}
                <div className="leading-tight">
                  <div className="text-xl font-display font-black uppercase text-white">{sp.name}</div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-amber-300">{sp.type}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {marquee && <style>{`@keyframes tvMarquee{from{transform:translateX(0)}to{transform:translateX(-50%)}} .tv-marquee{animation:tvMarquee ${Math.max(20, sponsors.length * 6)}s linear infinite}`}</style>}
    </div>
  );
}
